export function useCommandPalette() {
  const open = useState<boolean>('app:command-palette:open', () => false)

  function openCommandPalette() {
    open.value = true
  }

  function closeCommandPalette() {
    open.value = false
  }

  function toggleCommandPalette() {
    open.value = !open.value
  }

  return {
    open,
    openCommandPalette,
    closeCommandPalette,
    toggleCommandPalette,
  }
}
